import ButtonCircle from "../../../../shared/components/button_circle"
import ButtonBig from "../../../../shared/components/button_big"
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectGtoState } from "../../../../stateManagement/redux"
import ButtonSmall from "../../../../shared/components/button_small";
import { Tooltip } from '@mui/material';
import { MultiPositionSwitch } from "../../../../shared/components/MultiPositionSwitch";

export const ActivitiesList = ({ activities, ActiveCuadrilla, setActiveCuadrilla, cuadrillas, onChangeActivitiesField, activeFieldForActivities, errors }: { activities: any[], ActiveCuadrilla: string, setActiveCuadrilla: any, cuadrillas: any[], onChangeActivitiesField: any, activeFieldForActivities: any, errors: any }) => {

    const [showModifyNameModal, setShowModifyNameModal] = useState(false)

    const mainState = useSelector(selectGtoState);

    const [activeItem, setActiveItem] = useState<any>(null)

    const [newValue, setNewValue] = useState("")

    const [filteredActivities, setFilteredActivities] = useState<any[]>([])

    const [activeActivity, setActiveActivity] = useState<any>(undefined)

    const [cartaFilter, setCartaFilter] = useState("All")

    useEffect(() => {

        try {
            let filtedActivities = ActiveCuadrilla === ''
                ? activities
                : activities.filter((a) => a.members === ActiveCuadrilla)

            if (cartaFilter !== "All") {
                filtedActivities = filtedActivities?.filter(fa => fa.haveCart.toLowerCase() === cartaFilter?.toLowerCase())
            }

            setFilteredActivities(filtedActivities)

            setActiveActivity(undefined)
        } catch (error) {

        }

    }, [activities, ActiveCuadrilla, cartaFilter])


    const onClickChangeLocation = (c: any) => {
        setShowModifyNameModal(true)
        setActiveItem(c)
        setNewValue(c.location)
    }

    const onChageLocationName = () => {
        const cleanValue = newValue?.replace(activeFieldForActivities, '').trim()
        const preValue = activeItem?.location?.replace(activeFieldForActivities, '').trim()
        onChangeActivitiesField('Pozo', preValue, cleanValue)
        setShowModifyNameModal(false)
    }

    const onClickViewVariables = (c: any) => {
        const activities = mainState?.activitiesWithCarts?.find((a) => a.position === c.line)
        if (activities) {
            setActiveActivity(activities)
        }
    }

    const onClickViewList = () => {
        setActiveActivity(undefined)
    }

    const onChangeSwitch = (e: any) => {
        setCartaFilter(e)
    }

    if (activeActivity) {
        return (
            <div className="consolidate_files_container_cuadrillas_container">
                <div className="consolidate_files_container_custom_input">
                    <ButtonSmall text={"Ver lista"} icon="/assets/icons/back.svg" onClick={onClickViewList} />
                </div>
                <div className='consolidate_files_container_table_container'>
                    {Object.keys(activeActivity).map((a, i) => {

                        const omit = ['line', 'position', 'haveCart', 'dynCarts', 'fileName', 'taskId', 'originFlow']

                        if (omit.includes(a.trim())) return null

                        const errorsForFile = errors[activeActivity["fileName"]]

                        let isColumnInError = errorsForFile.find((e: any) => e.variable === a.trim())

                        if (isColumnInError) {
                            const doesMessageHaveError = isColumnInError.valueWithError === activeActivity[a]
                            // console.log({ doesMessageHaveError, isColumnInError, activeActivity: activeActivity[a], a })
                            if (!doesMessageHaveError || isColumnInError.type === 'warning') {
                                isColumnInError = undefined
                            }
                        }

                        return (
                            <Tooltip key={i} title={isColumnInError ? isColumnInError.error : ''} arrow>
                                <div key={i} className={`consolidate_files_container_activity_detail_container ${isColumnInError && 'consolidate_files_container_alert_row'}`}>
                                    <div>{a}</div>
                                    <div>{activeActivity[a]}</div>
                                </div>
                            </Tooltip>
                        )
                    })}</div>
            </div>
        )
    }


    return (
        <>
            {/* Modal */}
            {showModifyNameModal &&
                <div className='consolidate_files_container_modal_edit_container'>
                    <div className="consolidate_files_container_modal_edit_container_input_container" >
                        <div className="consolidate_files_container_header">
                            <div>Modificar Locacion Actividad</div>
                            <ButtonCircle icon="/assets/icons/close.svg" iconHeight={15} iconWidth={15} onClick={() => setShowModifyNameModal(false)} />
                        </div>
                        <div className="consolidate_files_container_body">
                            <div className="consolidate_files_container_custom_input">
                                <label htmlFor="file">Valor Actual : </label>
                                <div className="consolidate_files_container_custom_input_value">{activeItem?.location}</div>
                            </div>
                            <div className="consolidate_files_container_custom_input">
                                <label htmlFor="file">Nuevo Valor </label>
                                <input type="text" value={newValue} onChange={(e) => setNewValue(e.target.value)} className="consolidate_files_container_input" />
                            </div>
                            <ButtonBig text='Guardar Cambios' onClick={() => onChageLocationName()} />
                        </div>
                    </div>
                </div>}
            <div className="consolidate_files_container_cuadrillas_container">
                <div className="consolidate_files_container_table_custom_filter">
                    <div>
                        <label htmlFor="file">Ingenieros : </label>
                        <select id="activity" name="activity" className='Upload_files_container_form_section_select' value={ActiveCuadrilla} onChange={(e) => setActiveCuadrilla(e.target.value)}>
                            <option value=''>Todos</option>
                            {cuadrillas.map((f, index) => <option key={index} value={f.member}>{f.member}</option>)}
                        </select>
                    </div>
                    <div>
                        <MultiPositionSwitch value={cartaFilter} label="Carta" options={['All', 'Si', 'No']} onChange={onChangeSwitch} />
                    </div>
                </div>
                <div className='consolidate_files_container_table_container'>
                    <div className='consolidate_files_container_table_header'>
                        <div>Pozo</div>
                        <div>Ingenieros</div>
                        <div>Carta</div>
                        <div></div>
                        <div />
                    </div>
                    <div className="consolidate_files_container_table_info_container">
                        {filteredActivities.map((c, i) => (
                            <div key={i} className={`consolidate_files_container_table_row ${!c.isNameOk && 'consolidate_files_container_alert_row'}`}>
                                <div>{c.location}</div>
                                <div>{c.members}</div>
                                <div className={`${c?.haveCart === "NO" && "consolidate_files_container_table_row_warning"}`}>{c?.haveCart}</div>
                                <div className="consolidate_files_container_table_row_buttons">
                                    <ButtonBig text='Ver Variables' onClick={() => onClickViewVariables(c)} />
                                    {/* <ButtonBig text='Ver Detalles' onClick={() => onClickViewCart(c)} /> */}
                                    <ButtonBig text='Modificar Locacion' onClick={() => onClickChangeLocation(c)} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}